// src/components/mobile/MobileStickyActionBar.tsx
import React from 'react';
import '../../styles/mobile/mobile-common.css';

interface ActionButton {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
}

interface MobileStickyActionBarProps {
  primaryAction: ActionButton & { count?: number };
  secondaryActions?: ActionButton[];
  className?: string;
}

export const MobileStickyActionBar: React.FC<MobileStickyActionBarProps> = ({
  primaryAction,
  secondaryActions = [],
  className = ''
}) => {
  const renderButton = (action: ActionButton & { count?: number }, isPrimary: boolean = false) => {
    const variant = action.variant || (isPrimary ? 'primary' : 'secondary');
    
    return (
      <button
        onClick={action.onClick}
        disabled={action.disabled}
        className={`mobile-btn mobile-btn-${variant}`}
        style={{
          flex: isPrimary ? 1 : undefined,
          height: 'var(--mobile-input)',
          padding: '0 var(--space-4)',
          borderRadius: 'var(--radius-sm)',
          fontSize: 'var(--mobile-body)',
          fontWeight: 600,
          border: 'none',
          cursor: action.disabled ? 'not-allowed' : 'pointer',
          transition: 'all 0.15s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'var(--space-2)',
          minWidth: '44px',
          background: variant === 'primary' ? 'var(--panel-header-bg, var(--primary))' : 'color-mix(in srgb, var(--panel-header-bg, white) 8%, white)',
          color: variant === 'primary' ? 'var(--text-on-header, white)' : 'var(--action-preview-text, var(--gray-900))',
          opacity: action.disabled ? 0.5 : 1
        }}
      >
        <span>{action.label}</span>
        {isPrimary && action.count !== undefined && (
          <span
            style={{
              fontSize: 'var(--mobile-tiny)',
              background: 'color-mix(in srgb, var(--text-on-header, white) 20%, transparent)',
              padding: '2px 6px',
              borderRadius: 'var(--radius-sm)',
              fontWeight: 600
            }}
          >
            {action.count}
          </span>
        )}
      </button>
    );
  };

  return (
    <div
      className={`mobile-sticky-action-bar ${className}`}
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 'var(--z-sticky)',
        height: 'var(--mobile-action-bar)',
        background: 'color-mix(in srgb, var(--panel-header-bg, white) 8%, white)',
        borderTop: '1px solid var(--panel-header-border, var(--gray-200))',
        padding: 'var(--space-2) var(--space-3)',
        boxShadow: 'var(--panel-shadow, 0 -2px 4px rgba(0, 0, 0, 0.1))',
        display: 'flex',
        gap: 'var(--space-2)'
      }}
    >
      {secondaryActions.map((action, index) => (
        <div key={index}>{renderButton(action, false)}</div>
      ))}
      {renderButton(primaryAction, true)}
    </div>
  );
};
